var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "#878787",
    stroke: "#878787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set",
    transform: "translate(-100.000000, -1087.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,1117 C108.268,1117 102,1110.73 102,1103 C102,1095.27 108.268,1089 116,1089 C123.732,1089 130,1095.27 130,1103 C130,1110.73 123.732,1117 116,1117 L116,1117 Z M116,1087 C107.164,1087 100,1094.16 100,1103 C100,1111.84 107.164,1119 116,1119 C124.836,1119 132,1111.84 132,1103 C132,1094.16 124.836,1087 116,1087 L116,1087 Z M120.536,1102.12 L112.879,1094.46 C112.488,1094.07 111.855,1094.07 111.464,1094.46 C111.074,1094.86 111.074,1095.49 111.464,1095.88 L118.586,1103 L111.464,1110.12 C111.074,1110.51 111.074,1111.14 111.464,1111.54 C111.855,1111.93 112.488,1111.93 112.879,1111.54 L120.536,1103.88 C120.775,1103.64 120.85,1103.31 120.795,1103 C120.85,1102.69 120.775,1102.36 120.536,1102.12 L120.536,1102.12 Z",
    id: "chevron-right-circle"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.fc4ba4500d662a012745db0045802c78.svg";
export { ForwardRef as ReactComponent };